import React from 'react';
export function ProblemSection() {
  return <section className="bg-gray-950 text-white py-16 px-4" data-id="element-97">
      <div className="max-w-4xl mx-auto" data-id="element-98">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-99">
          El problema no es la bici. No es la edad. No es el tiempo.
        </h2>

        <div className="text-lg md:text-xl text-gray-300 space-y-4 mb-12" data-id="element-100">
          <p data-id="element-101">
            Llega el domingo. Salís con el grupo. Los primeros kilómetros van
            bien.
          </p>
          <p data-id="element-102">
            Pero en algún punto de la ruta pasa algo que nadie dice en voz alta:
          </p>
          <p className="font-bold text-white" data-id="element-103">
            El grupo se va. Y vos te quedás atrás.
          </p>
          <p data-id="element-104">
            Y lo peor no es quedarte atrás. Es llegar a casa con la espalda
            rota, las rodillas avisando y sin energía para estar con tu familia.
            Y el lunes en la oficina moviéndote despacio para que no noten que
            te duele el cuello.
          </p>
          <p data-id="element-105">Invertís tiempo. Invertís plata. Invertís esfuerzo.</p>
          <p className="font-bold text-white" data-id="element-106">
            Y el cuerpo no responde como debería.
          </p>
        </div>

        <h3 className="text-2xl font-bold mb-6" data-id="element-107">¿Te suena alguna de estas?</h3>

        <div className="space-y-4 bg-gray-900 border border-gray-800 rounded-lg p-6" data-id="element-108">
          <div className="flex items-start gap-3" data-id="element-109">
            <span className="text-2xl" data-id="element-110">😤</span>
            <p data-id="element-111">
              Te agarró la pájara en el kilómetro 50 aunque creías que habías
              comido bien
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-112">
            <span className="text-2xl" data-id="element-113">😣</span>
            <p data-id="element-114">
              Llegás a casa con dolor de espalda o rodilla todos los domingos
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-115">
            <span className="text-2xl" data-id="element-116">😞</span>
            <p data-id="element-117">
              El grupo aceleró en la cuesta de siempre y no pudiste seguir el
              ritmo
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-118">
            <span className="text-2xl" data-id="element-119">💸</span>
            <p data-id="element-120">
              Gastás en geles y barritas que no sabés si realmente funcionan
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-121">
            <span className="text-2xl" data-id="element-122">🔧</span>
            <p data-id="element-123">
              Pinchaste a 30 kilómetros de casa y no sabías bien cómo resolverlo
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-124">
            <span className="text-2xl" data-id="element-125">😴</span>
            <p data-id="element-126">El lunes te levantás destruido y con el cuello rígido</p>
          </div>
        </div>

        <p className="text-xl font-semibold text-center mt-8 text-green-400" data-id="element-127">
          Si marcaste aunque sea una, este sistema es para vos.
        </p>
      </div>
    </section>;
}